export const colorInput = '#173fb5';
export const colorOrigin = '#16ab39';
export const colorTarget = '#b21e1e';

export function toCoords(location: { latitude: number; longitude: number }): CoordinatePair {
    return [location.latitude as Latitude, location.longitude as Longitude];
}
